import React from "react";

function PianoGuitarIcon() {
  return (
    <svg
      width="33"
      height="38"
      viewBox="0 0 33 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6_1929)">
        <path
          d="M5.00366 23.1395H6.96817V30.0585H0.909485V10.2866H5.00366V23.1395ZM13.2266 10.2866H11.2621V23.1395H9.2169V30.0585H15.2756V23.1395H13.2266V10.2866ZM21.8893 10.2866H19.4888V23.1395H17.7163V30.0585H23.775V23.1395H21.8873V10.2866H21.8893ZM28.1477 10.2866V23.1395H26.0622V30.0585H32.1228V10.2866H28.1477Z"
          fill="white"
        />
        <path
          d="M10.1444 7.38306H6.19427V21.4918H10.1444V7.38306Z"
          fill="#282827"
        />
        <path
          d="M18.3616 7.38306H14.4077V21.4918H18.3616V7.38306Z"
          fill="#282827"
        />
        <path
          d="M26.9917 7.38306H23.0415V21.4918H26.9917V7.38306Z"
          fill="#282827"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_1929">
          <rect
            width="31.2133"
            height="22.6754"
            fill="white"
            transform="translate(0.909485 7.38306)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PianoGuitarIcon;
